import { InjectionToken } from "@angular/core";

export const NMO_AUTH_CONFIG = new InjectionToken('angular-oauth2-oidc Config');
export const SERVER_GUARD_REDIRECT_URL = new InjectionToken('URL to redirect when Guard cancles Navigation on server');
export const UNAUTHORIZED_REDIRECT_URL = new InjectionToken('URL to redirect when User is unauthorized');
export const NMO_DISABLE_AUTOMATIC_INIT = new InjectionToken('Disable Initial Automatic Module Init');
export const FALLBACK_REDIRECT_URL = new InjectionToken('A fallback URL to redirect at callback page');
